import React from 'react';
import { RenderIf } from 'react-rainbow-components';
import { Close } from '@rainbow-modules/icons';
import { PopupCloseButton, PopupContainer, PopupIframe as StyledPopupIframe, StyledSpinner, PopupInnerContainer, } from './styled';
var PopupIframe = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, src = _a.src, title = _a.title, isOpen = _a.isOpen, isLoading = _a.isLoading, onRequestClose = _a.onRequestClose, onLoad = _a.onLoad;
    if (!isOpen)
        return null;
    return (React.createElement(PopupContainer, { id: id },
        React.createElement(PopupInnerContainer, null,
            React.createElement(RenderIf, { isTrue: isLoading },
                React.createElement(StyledSpinner, { type: "arc", variant: "brand" })),
            React.createElement(StyledPopupIframe, { className: className, style: style, src: src, title: title, isLoading: isLoading, onLoad: onLoad })),
        React.createElement(PopupCloseButton, { id: "modal-close-button", icon: React.createElement(Close, null), size: "x-small", onClick: onRequestClose })));
};
export default PopupIframe;
//# sourceMappingURL=popup.js.map